export var getHistoryStatus = function (status, expired) {
    return expired ? 'expired' : status;
};
